/** Map Deepgram hold-mic status onto the manufacturing dictate pad lifecycle. */
import type { DeepgramHoldMicStatus } from "@/lib/asr/deepgramHoldMicSession";

export type DictateSessionState =
  | "idle"
  | "unsupported"
  | "recording"
  | "stopped"
  | "error";

export function mapHoldMicToDictateState(args: {
  isSupported: boolean;
  micStatus: DeepgramHoldMicStatus;
  awaitingCommit: boolean;
}): DictateSessionState {
  if (!args.isSupported) return "unsupported";
  if (args.micStatus === "error") return "error";
  if (
    args.micStatus === "listening" ||
    args.micStatus === "starting" ||
    args.micStatus === "stopping"
  ) {
    return "recording";
  }
  if (args.awaitingCommit) return "stopped";
  return "idle";
}

export function mediaDevicesSupported(): boolean {
  return typeof navigator !== "undefined" && Boolean(navigator.mediaDevices?.getUserMedia);
}
